var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyXag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "#ADABB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6208 10.7775H17.5133L16.5083 8.081C16.4692 7.97038 16.3978 7.87405 16.3033 7.8045L10.6208 10.7775ZM10.6018 7.577C10.8463 6.921 11.3833 6.5 11.9753 6.5H16.0503C16.6428 6.5 17.1803 6.921 17.4243 7.577L18.4288 10.2735C18.7298 11.0825 18.2433 12 17.5133 12H10.5133C9.78327 12 9.29627 11.0825 9.59727 10.2735L10.6018 7.577ZM5.11427 17.7775H11.9928L10.9888 15.081C10.9494 14.9702 10.8777 14.8739 10.7828 14.8045L5.11427 17.7775ZM5.09527 14.577C5.33977 13.921 5.87727 13.5 6.46877 13.5H10.5308C11.1228 13.5 11.6598 13.921 11.9043 14.577L12.9088 17.2735C13.2103 18.0825 12.7233 19 11.9923 19H5.00577C4.27577 19 3.78927 18.0825 4.09077 17.2735L5.09527 14.577ZM23.0403 17.7775H16.1153L21.8303 14.805C21.9193 14.868 21.9918 14.963 22.0363 15.0815L23.0403 17.7775ZM17.4688 13.5C16.8768 13.5 16.3398 13.921 16.0958 14.577L15.0908 17.2735C14.7903 18.0825 15.2768 19 16.0073 19H23.0403C23.7703 19 24.2573 18.0825 23.9558 17.2735L22.9508 14.577C22.7083 13.921 22.1703 13.5 21.5788 13.5H17.4688Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyXag);
export default __webpack_public_path__ + "static/media/Currency=XAG.de5ab635d997c7d9e9e67e7aed595db2.svg";
export { ForwardRef as ReactComponent };